import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const companiesManagementReducer = foxGridReducer(
  gridNames.companiesManagement,
);

export default companiesManagementReducer;
